// src/routes.js
import Dashboard from "../pages/dashboard/Dashboard";
import UserManagement from "../pages/user/UserManagement";
import SourceBusiness from "../pages/sourceBusiness/SourceBusiness";
import OfferManagement from "../pages/offers/OfferManagement";
import VoucherBatch from "../pages/voucher/VoucherBatch";
import Collection from "../pages/collection/Collection";
import Campaigns from "../pages/campaigns/Campaign";
import PlatFormUser from "../pages/platform-report/PlatForm.user";
import PlatFormSummary from "../pages/platform-report/PlatForm.summary";
import PrivateRoute from "../utils/PrivateRoute";
import ChatbotManagement from "../pages/chatbots/ChatbotManagement";
import CategoryPage from "../pages/chatbots/categorySection";
import CountrySection from "../pages/chatbots/CountrySection";
import CardTypeSection from "../pages/chatbots/CardTypeSection";

const appRoutes = [
    { path: "", element: <PrivateRoute><Dashboard /></PrivateRoute> },
    { path: "user_management", element: <PrivateRoute><UserManagement /></PrivateRoute> },
    { path: "source_business", element: <PrivateRoute><SourceBusiness /></PrivateRoute> },
    { path: "offerings", element: <PrivateRoute><OfferManagement /></PrivateRoute> },
    { path: "vouchers", element: <PrivateRoute><VoucherBatch /></PrivateRoute> },
    { path: "collections", element: <PrivateRoute><Collection /></PrivateRoute> },
    { path: "campaigns", element: <PrivateRoute><Campaigns /></PrivateRoute> },
    { path: "chatbot-management", element: <PrivateRoute><ChatbotManagement /></PrivateRoute> },
    { path: "chatbot-management/category", element: <PrivateRoute><CategoryPage /></PrivateRoute> },
    { path: "chatbot-management/country", element: <PrivateRoute><CountrySection /></PrivateRoute> },
    { path: "chatbot-management/card", element: <PrivateRoute><CardTypeSection /></PrivateRoute> },
    { path: "platform-report/user", element: <PrivateRoute><PlatFormUser /></PrivateRoute> },
    { path: "platform-report/brand", element: <PrivateRoute><PlatFormSummary /></PrivateRoute> },
];

export default appRoutes;
